import React, { useContext, useEffect } from "react";
import ProgressCourse from "../components/courses/ProgressCourse";
import SingleSection from "../components/courses/SingleSection";
import SingleLesson from "../components/lessons/SingleLesson";
import MaterialHelp from "../components/ayuda/MaterialHelp";
import { CoursesContext } from "../context/CoursesContext";
import CourseNotes from "../components/notes/CourseNotes";
import LineContact from "../components/line/LineContact";
import Sections from "../components/courses/Sections";
import { AuthContext } from "../context/AuthContext";
import { Router } from "@reach/router";
import { getValue } from "../utils";
import { ModalContext } from "../context/ModalContext";
import AcceptTermsModal from "../components/global/AcceptTermsModal";
import BBPClauses from "../components/global/BBPClauses";
import ChooseFinalExamModal from "../components/tests/ChooseFinalExamModal";
import { CourseAccessesContext } from "../context/CourseAccessesContext";
import {
  getPurchaseAccesses,
  hasChosenFinalExam,
  hasFinalExamAttempt,
  hasCompletedSections,
  mustChooseFinalExam,
} from "../utils/course";

const ACCEPT_TIMEOUT = 500;

const SingleCourse = ({ course_id }) => {
  const { course, courses, getCourse, getMyCourses, clearCourse } =
    useContext(CoursesContext);
  const { course_accesses } = useContext(CourseAccessesContext);
  const { modalComponent } = useContext(ModalContext);
  const { user } = useContext(AuthContext);

  useEffect(() => {
    clearCourse();
    getCourse(course_id);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [course_id]);

  useEffect(() => {
    if (user !== null) {
      getCourse(course_id);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user]);

  /*
  useEffect(() => {
    if (parseInt(course_id) === 6 && course && course !== null) {
      handleBBPTerms();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [course]);
  */

  useEffect(() => {
    getMyCourses();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (
      course &&
      course !== null &&
      Array.isArray(course_accesses) &&
      Array.isArray(courses)
    ) {
      handleChooseFinalExam();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [course, course_accesses, courses]);

  useEffect(() => {
    return clearCourse;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleChooseFinalExam = () => {
    const must_choose = mustChooseFinalExam(course);
    console.log("[final-exam] course", course.course_id, course.name);
    console.log("[final-exam] course.course_access", course.course_access);
    console.log("[final-exam] mustChooseFinalExam", must_choose, {
      has_attempt: hasFinalExamAttempt(course),
      chose_final_exam: course.course_access?.chose_final_exam,
      mode: course.course_access?.purchase?.product?.mode,
    });
    if (!must_choose) return;
    const { course_access } = course;
    const { purchase_id } = course_access;
    const has_chosen = hasChosenFinalExam(course_accesses, purchase_id);
    console.log("[final-exam] hasChosenFinalExam", has_chosen, {
      purchase_id,
      accesses: course_accesses.map((a) => ({
        course_access_id: a.course_access_id,
        course_id: a.course_id,
        purchase_id: a.purchase_id,
        chose_final_exam: a.chose_final_exam,
        final_exam: a.final_exam,
      })),
    });
    if (has_chosen) return;
    const accesses = getPurchaseAccesses(course_accesses, purchase_id);
    const completed = hasCompletedSections(courses, accesses);
    console.log("[final-exam] hasCompletedSections", completed, {
      purchase_accesses: accesses.length,
      mycourses: courses.map((c) => ({
        course_id: c.course_id,
        completed_sections: c.completed_sections,
      })),
    });
    if (!completed) return;
    console.log("[final-exam] SHOWING MODAL");
    setTimeout(() => {
      modalComponent(
        "¡Felicidades! Ya puedes elegir tu examen final",
        <ChooseFinalExamModal course_id={course_id} accesses={accesses} />,
      );
    }, ACCEPT_TIMEOUT);
  };

  const handleBBPTerms = () => {
    const acceptedClauses = getValue(user, "acceptedBBP");
    if (!acceptedClauses) {
      return setTimeout(() => {
        modalComponent(
          "Aceptar Cláusulas Especiales",
          <AcceptTermsModal
            acceptKey="acceptedBBP"
            name="Cláusulas Especiales Block Burn Pilates"
          >
            <BBPClauses />
          </AcceptTermsModal>,
        );
      }, ACCEPT_TIMEOUT);
    }
  };

  const renderContent = () => {
    if (course && course !== null) {
      if (user !== null) {
        return (
          <div className="position-relative">
            <CourseNotes />
            <ProgressCourse course_id={course.course_id} course={course} />
            <div className="course-content">
              <Router>
                <Sections path="/" course_id={course_id} />
                <SingleSection
                  path="/sections/:section_id"
                  course_id={course_id}
                />
                <SingleLesson path="/sections/:section_id/lessons/:lesson_id" />
              </Router>
            </div>
            <MaterialHelp />
            <LineContact />
          </div>
        );
      }
    }
    return (
      <div className="container-fluid px-0 text-center my-5">
        <div className="spinner-border"></div>
      </div>
    );
  };

  return <div className="container-fluid px-0">{renderContent()}</div>;
};

export default SingleCourse;
